<template>
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1000.981 964.677"
    style="width: 100%; height: 100%"
  >
    <g id="Layer_2-2" data-name="Layer 2">
      <g>
        <g>
          <rect
            x="682.62"
            y="14.392"
            width="172.061"
            height="223.958"
            fill="#f4f4f4"
          ></rect>
          <rect
            x="854.681"
            y="14.392"
            width="5.582"
            height="223.958"
            transform="translate(1714.944 252.743) rotate(180)"
            fill="#f4f4f4"
          ></rect>
          <rect
            x="854.681"
            y="14.392"
            width="5.582"
            height="223.958"
            transform="translate(1714.944 252.743) rotate(180)"
            fill="#292a2e"
            opacity=".05"
          ></rect>
          <rect
            x="713.963"
            y="55.189"
            width="109.375"
            height="142.365"
            fill="#292a2e"
            opacity=".05"
          ></rect>
          <rect
            x="817.638"
            y="55.189"
            width="5.7"
            height="142.365"
            fill="#292a2e"
            opacity=".03"
          ></rect>
          <rect
            x="854.681"
            y="293.426"
            width="140.718"
            height="142.01"
            fill="#f4f4f4"
          ></rect>
          <rect
            x="880.315"
            y="319.295"
            width="89.451"
            height="90.272"
            fill="#292a2e"
            opacity=".05"
          ></rect>
          <rect
            x="995.399"
            y="293.426"
            width="5.582"
            height="142.01"
            transform="translate(1996.38 728.862) rotate(180)"
            fill="#f4f4f4"
          ></rect>
          <rect
            x="995.399"
            y="293.426"
            width="5.582"
            height="142.01"
            transform="translate(1996.38 728.862) rotate(180)"
            fill="#292a2e"
            opacity=".05"
          ></rect>
          <rect
            x="964.066"
            y="319.295"
            width="5.7"
            height="90.272"
            fill="#292a2e"
            opacity=".03"
          ></rect>
        </g>
        <g>
          <rect
            id="c_3_c"
            x="18.674"
            y="0"
            width="468.757"
            height="468.757"
            fill="#f4f4f4"
          ></rect>
          <rect
            id="c_3_c-2"
            data-name="c_3_c"
            x="487.431"
            y="0"
            width="5.373"
            height="468.757"
            fill="#f4f4f4"
          ></rect>
          <rect
            id="c_3_c-3"
            data-name="c_3_c"
            x="487.431"
            y="0"
            width="5.373"
            height="468.757"
            fill="#292a2e"
            opacity=".05"
          ></rect>
          <polygon
            id="c_3_c-4"
            data-name="c_3_c"
            points="373.872 323.012 373.872 200.37 273.41 200.37 273.41 271.622 117.794 271.622 117.794 397.784 51.655 397.784 51.655 468.757 117.794 468.757 130.536 468.757 464.882 468.757 464.882 323.012 373.872 323.012"
            fill="#292a2e"
            opacity=".05"
          ></polygon>
          <g id="c_3_wh">
            <rect
              id="c_3_wh-2"
              data-name="c_3_wh"
              x="286.306"
              y="213.686"
              width="73.158"
              height="13.316"
              fill="#fffffa"
              opacity=".34"
            ></rect>
            <rect
              id="c_3_wh-3"
              data-name="c_3_wh"
              x="286.306"
              y="241.28"
              width="73.158"
              height="13.316"
              fill="#fffffa"
              opacity=".34"
            ></rect>
            <rect
              id="c_3_wh-4"
              data-name="c_3_wh"
              x="286.306"
              y="268.874"
              width="73.158"
              height="13.316"
              fill="#fffffa"
              opacity=".34"
            ></rect>
          </g>
          <g id="c_3_wh-5" data-name="c_3_wh">
            <rect
              id="c_3_wh-6"
              data-name="c_3_wh"
              x="438.425"
              y="335.938"
              width="13.484"
              height="13.316"
              fill="#fffffa"
              opacity=".34"
            ></rect>
            <rect
              id="c_3_wh-7"
              data-name="c_3_wh"
              x="438.425"
              y="363.532"
              width="13.484"
              height="13.316"
              fill="#fffffa"
              opacity=".34"
            ></rect>
            <rect
              id="c_3_wh-8"
              data-name="c_3_wh"
              x="438.425"
              y="391.126"
              width="13.484"
              height="13.316"
              fill="#fffffa"
              opacity=".34"
            ></rect>
            <rect
              id="c_3_wh-9"
              data-name="c_3_wh"
              x="413.48"
              y="335.938"
              width="13.484"
              height="13.316"
              fill="#fffffa"
              opacity=".34"
            ></rect>
            <rect
              id="c_3_wh-10"
              data-name="c_3_wh"
              x="413.48"
              y="363.532"
              width="13.484"
              height="13.316"
              fill="#fffffa"
              opacity=".34"
            ></rect>
            <rect
              id="c_3_wh-11"
              data-name="c_3_wh"
              x="413.48"
              y="391.126"
              width="13.484"
              height="13.316"
              fill="#fffffa"
              opacity=".34"
            ></rect>
            <rect
              id="c_3_wh-12"
              data-name="c_3_wh"
              x="389.209"
              y="335.938"
              width="13.484"
              height="13.316"
              fill="#fffffa"
              opacity=".34"
            ></rect>
            <rect
              id="c_3_wh-13"
              data-name="c_3_wh"
              x="389.209"
              y="363.532"
              width="13.484"
              height="13.316"
              fill="#fffffa"
              opacity=".34"
            ></rect>
            <rect
              id="c_3_wh-14"
              data-name="c_3_wh"
              x="389.209"
              y="391.126"
              width="13.484"
              height="13.316"
              fill="#fffffa"
              opacity=".34"
            ></rect>
          </g>
          <polygon
            points="487.431 231.749 393.109 231.749 393.109 0 385.309 0 385.309 231.749 130.536 231.749 130.536 0 122.735 0 122.735 231.749 18.674 231.749 18.674 239.55 122.735 239.55 122.735 468.757 130.536 468.757 130.536 239.55 385.309 239.55 385.309 468.757 393.109 468.757 393.109 239.55 487.431 239.55 487.431 231.749"
            fill="#fff"
          ></polygon>
          <rect
            id="c_3_c-5"
            data-name="c_3_c"
            y="468.192"
            width="506.105"
            height="15.589"
            fill="#f4f4f4"
          ></rect>
          <rect
            id="c_3_c-6"
            data-name="c_3_c"
            y="468.192"
            width="506.105"
            height="15.589"
            fill="#292a2e"
            opacity=".1"
          ></rect>
          <rect
            id="c_3_c-7"
            data-name="c_3_c"
            x="506.105"
            y="468.192"
            width="7.307"
            height="15.589"
            fill="#292a2e"
            opacity=".1"
          ></rect>
          <rect
            id="c_3_c-8"
            data-name="c_3_c"
            x="506.105"
            y="468.192"
            width="7.307"
            height="15.589"
            fill="#292a2e"
            opacity=".1"
          ></rect>
        </g>
        <g>
          <g>
            <rect
              x="727.508"
              y="944.854"
              width="26.039"
              height="17.39"
              fill="#292a2e"
              opacity=".05"
            ></rect>
            <rect
              x="890.971"
              y="944.854"
              width="26.039"
              height="17.39"
              fill="#292a2e"
              opacity=".05"
            ></rect>
          </g>
          <rect
            x="703.639"
            y="679.905"
            width="237.239"
            height="264.949"
            fill="#f4f4f4"
          ></rect>
          <rect
            x="703.639"
            y="679.905"
            width="237.239"
            height="264.949"
            fill="#292a2e"
            opacity=".03"
          ></rect>
          <rect
            x="640.633"
            y="679.905"
            width="237.239"
            height="264.949"
            fill="#f4f4f4"
          ></rect>
          <g>
            <rect
              x="664.502"
              y="944.854"
              width="26.039"
              height="17.39"
              fill="#292a2e"
              opacity=".05"
            ></rect>
            <rect
              x="827.964"
              y="944.854"
              width="26.039"
              height="17.39"
              fill="#292a2e"
              opacity=".05"
            ></rect>
          </g>
          <rect
            x="653.395"
            y="696.287"
            width="211.713"
            height="67.198"
            fill="#fff"
            opacity=".7"
          ></rect>
          <rect
            x="653.395"
            y="779.933"
            width="211.713"
            height="67.198"
            fill="#fff"
            opacity=".7"
          ></rect>
          <rect
            x="653.395"
            y="863.578"
            width="211.713"
            height="67.198"
            fill="#fff"
            opacity=".7"
          ></rect>
          <circle
            cx="759.252"
            cy="729.886"
            r="9.403"
            fill="#292a2e"
            opacity=".05"
          ></circle>
          <circle
            cx="759.252"
            cy="813.532"
            r="9.403"
            fill="#292a2e"
            opacity=".05"
          ></circle>
          <circle
            cx="759.252"
            cy="897.178"
            r="9.403"
            fill="#292a2e"
            opacity=".05"
          ></circle>
        </g>
        <g>
          <path
            d="m111.498,833.535c-.256,0-.512-.098-.707-.293-1.409-1.409-3.706-27.259-9.892-104.223-2.531-31.492-4.922-61.238-6.667-79.315-.125-1.291-.625-1.441-.79-1.491-2.388-.721-9.652,5.007-13.707,10.022-.347.429-.977.497-1.407.149-.429-.348-.496-.977-.149-1.407,2.682-3.316,11.422-12.009,15.838-10.68.891.268,1.996,1.042,2.206,3.214,1.746,18.093,4.137,47.847,6.669,79.347,3.759,46.77,8.018,99.756,9.417,103.093.282.391.247.939-.105,1.291-.195.195-.451.293-.707.293Z"
            fill="#494949"
          ></path>
          <ellipse
            cx="73.901"
            cy="660.721"
            rx="38.507"
            ry="28.398"
            transform="translate(-397.005 191.402) rotate(-38.715)"
            fill="#0cbc8b"
          ></ellipse>
          <ellipse
            cx="73.901"
            cy="660.721"
            rx="38.507"
            ry="28.398"
            transform="translate(-397.005 191.402) rotate(-38.715)"
            fill="#fff"
            opacity=".2"
          ></ellipse>
          <path
            d="m48.508,687.914c-.112,0-.225-.038-.319-.115-.212-.176-.242-.491-.065-.704l47.291-57.029c.176-.211.491-.242.704-.065.212.176.242.491.065.704l-47.291,57.029c-.099.119-.241.181-.385.181Z"
            fill="#fff"
          ></path>
          <path
            d="m121.812,821.31c-.109,0-.22-.018-.329-.056-.521-.181-.797-.751-.616-1.273l17.764-51.087c1.066-3.065,3.586-5.351,6.741-6.112,3.156-.763,6.44.122,8.788,2.364l9.391,8.971c.399.381.414,1.015.032,1.414-.382.399-1.015.413-1.414.032l-9.391-8.971c-1.853-1.77-4.445-2.469-6.937-1.867-2.49.601-4.479,2.405-5.321,4.825l-17.764,51.087c-.144.413-.53.672-.944.672Z"
            fill="#494949"
          ></path>
          <ellipse
            cx="165.891"
            cy="772.203"
            rx="28.398"
            ry="38.507"
            transform="translate(-443.447 269.685) rotate(-38.363)"
            fill="#0cbc8b"
          ></ellipse>
          <path
            d="m103.428,830.277c-.452,0-.862-.309-.972-.768l-29.811-124.645c-.422-1.767-1.729-3.079-3.494-3.51-1.765-.429-3.53.133-4.718,1.506l-9.189,10.619c-.361.417-.994.463-1.411.102-.417-.361-.463-.993-.102-1.411l9.189-10.619c1.665-1.924,4.233-2.744,6.705-2.141,2.471.603,4.374,2.514,4.965,4.988l29.811,124.645c.128.537-.203,1.077-.74,1.205-.078.019-.156.027-.233.027Z"
            fill="#494949"
          ></path>
          <ellipse
            cx="64.446"
            cy="736.331"
            rx="38.507"
            ry="28.398"
            transform="translate(-672.098 674.37) rotate(-80.189)"
            fill="#0cbc8b"
          ></ellipse>
          <path
            d="m111.499,833.535c-.041,0-.082-.002-.124-.007-.548-.068-.938-.567-.871-1.115l19.036-154.558c.43-3.486,2.78-6.296,6.135-7.335,3.354-1.039,6.883-.049,9.207,2.583l21.758,24.643c.366.414.326,1.046-.088,1.412-.414.366-1.046.326-1.411-.087l-21.758-24.643c-1.797-2.035-4.522-2.799-7.116-1.997-2.593.803-4.41,2.975-4.741,5.669l-19.036,154.558c-.062.507-.494.878-.991.878Z"
            fill="#494949"
          ></path>
          <ellipse
            cx="155.261"
            cy="692.802"
            rx="28.398"
            ry="38.507"
            transform="translate(-526.128 493.325) rotate(-61.051)"
            fill="#0cbc8b"
          ></ellipse>
          <ellipse
            cx="165.891"
            cy="772.203"
            rx="28.398"
            ry="38.507"
            transform="translate(-443.447 269.685) rotate(-38.363)"
            fill="#fff"
            opacity=".2"
          ></ellipse>
          <ellipse
            cx="64.446"
            cy="736.331"
            rx="38.507"
            ry="28.398"
            transform="translate(-672.098 674.37) rotate(-80.189)"
            fill="#fff"
            opacity=".5"
          ></ellipse>
          <ellipse
            cx="155.261"
            cy="692.802"
            rx="28.398"
            ry="38.507"
            transform="translate(-526.128 493.325) rotate(-61.051)"
            fill="#fff"
            opacity=".5"
          ></ellipse>
          <polygon
            points="135.846 964.677 87.15 964.677 79.08 808.873 143.915 808.873 135.846 964.677"
            fill="#292a2e"
          ></polygon>
          <polygon
            points="135.846 964.677 87.15 964.677 79.08 808.873 143.915 808.873 135.846 964.677"
            fill="#fff"
            opacity=".3"
          ></polygon>
          <path
            d="m189.791,802.897c-.148,0-.294-.065-.393-.189l-47.799-60.386c-.171-.217-.135-.531.082-.703.218-.172.532-.134.703.082l47.799,60.386c.171.217.135.531-.082.703-.092.073-.202.108-.31.108Z"
            fill="#fff"
          ></path>
          <path
            d="m185.778,716.279c-.102,0-.206-.031-.294-.096l-61.167-44.663c-.223-.163-.272-.476-.109-.699.163-.223.476-.272.699-.109l61.167,44.663c.223.163.272.476.109.699-.098.134-.25.205-.404.205Z"
            fill="#fff"
          ></path>
          <path
            d="m55.403,773.627c-.043,0-.086-.005-.129-.017-.267-.071-.425-.345-.354-.612l19.472-72.953c.071-.267.35-.424.612-.354.267.071.425.345.354.612l-19.472,72.953c-.06.224-.262.371-.482.371Z"
            fill="#fff"
          ></path>
        </g>
        <g>
          <g>
            <g>
              <rect
                x="137.472"
                y="55.037"
                width="634.688"
                height="693.975"
                rx="30"
                ry="30"
                fill="#fff"
              ></rect>
              <path
                d="m741.592,749.164H166.903c-17.093,0-31-13.907-31-31V84.189c0-17.093,13.907-31,31-31h574.688c17.094,0,31,13.907,31,31v633.975c0,17.093-13.906,31-31,31ZM166.903,55.189c-15.991,0-29,13.009-29,29v633.975c0,15.991,13.009,29,29,29h574.688c15.99,0,29-13.009,29-29V84.189c0-15.991-13.01-29-29-29H166.903Z"
                fill="#292a2e"
              ></path>
            </g>
            <path
              d="m771.591,84.185v23.188H136.907v-23.188c0-16.569,13.431-30,30-30h574.684c16.569,0,30,13.431,30,30Z"
              fill="#292a2e"
            ></path>
          </g>
          <g>
            <circle
              cx="242.731"
              cy="218.194"
              r="73.345"
              fill="#367cff"
              opacity=".1"
            ></circle>
            <circle
              cx="242.731"
              cy="189.563"
              r="25.475"
              fill="#367cff"
              opacity=".2"
            ></circle>
            <path
              d="m297.87,266.559c-13.44,15.31-33.16,24.98-55.14,24.98s-41.71-9.67-55.14-24.99c7.04-23.8,29.06-41.16,55.14-41.16s48.11,17.37,55.14,41.17Z"
              fill="#367cff"
              opacity=".2"
            ></path>
          </g>
          <rect
            x="171.464"
            y="341.574"
            width="112.406"
            height="12.992"
            rx="6.496"
            ry="6.496"
            fill="#367cff"
            opacity=".2"
          ></rect>
          <rect
            x="346.768"
            y="149.775"
            width="177.391"
            height="43.043"
            rx="10.565"
            ry="10.565"
            fill="#367cff"
            opacity=".1"
          ></rect>
          <rect
            x="346.768"
            y="216.614"
            width="244.215"
            height="10"
            rx="5"
            ry="5"
            fill="#367cff"
            opacity=".2"
          ></rect>
          <rect
            x="346.768"
            y="246.614"
            width="244.215"
            height="10"
            rx="5"
            ry="5"
            fill="#367cff"
            opacity=".2"
          ></rect>
          <rect
            x="346.768"
            y="276.614"
            width="204.215"
            height="10"
            rx="5"
            ry="5"
            fill="#367cff"
            opacity=".2"
          ></rect>
          <rect
            x="171.464"
            y="373.306"
            width="262.938"
            height="41.984"
            rx="9.391"
            ry="9.391"
            fill="#367cff"
            opacity=".1"
          ></rect>
          <rect
            x="470.821"
            y="341.574"
            width="112.406"
            height="12.992"
            rx="6.496"
            ry="6.496"
            fill="#367cff"
            opacity=".2"
          ></rect>
          <rect
            x="470.821"
            y="373.306"
            width="262.938"
            height="41.984"
            rx="9.391"
            ry="9.391"
            fill="#367cff"
            opacity=".1"
          ></rect>
          <rect
            x="171.464"
            y="450"
            width="112.406"
            height="12.992"
            rx="6.496"
            ry="6.496"
            fill="#367cff"
            opacity=".2"
          ></rect>
          <rect
            x="171.464"
            y="481.732"
            width="262.938"
            height="41.984"
            rx="9.391"
            ry="9.391"
            fill="#367cff"
            opacity=".1"
          ></rect>
          <rect
            x="470.821"
            y="450"
            width="112.406"
            height="12.992"
            rx="6.496"
            ry="6.496"
            fill="#367cff"
            opacity=".2"
          ></rect>
          <rect
            x="470.821"
            y="481.732"
            width="262.938"
            height="41.984"
            rx="9.391"
            ry="9.391"
            fill="#367cff"
            opacity=".1"
          ></rect>
          <rect
            x="171.464"
            y="558.426"
            width="112.406"
            height="12.992"
            rx="6.496"
            ry="6.496"
            fill="#367cff"
            opacity=".2"
          ></rect>
          <rect
            x="171.464"
            y="590.158"
            width="262.938"
            height="41.984"
            rx="9.391"
            ry="9.391"
            fill="#367cff"
            opacity=".1"
          ></rect>
          <rect
            x="470.821"
            y="558.426"
            width="112.406"
            height="12.992"
            rx="6.496"
            ry="6.496"
            fill="#367cff"
            opacity=".2"
          ></rect>
          <rect
            x="470.821"
            y="590.158"
            width="262.938"
            height="41.984"
            rx="9.391"
            ry="9.391"
            fill="#367cff"
            opacity=".1"
          ></rect>
          <rect
            x="366.791"
            y="664.853"
            width="174.913"
            height="42.884"
            rx="11.15"
            ry="11.15"
            fill="#367cff"
            opacity=".2"
          ></rect>
        </g>
        <g>
          <g id="b_4_ha">
            <path
              d="m480.87,179.288l16.16,19.086-1.001-3.277c-.577-2.203.555-4.609,2.724-5.301,2.314-.738,4.743.62,5.351,2.939l7.388,27.819c1.939,7.303-2.297,14.82-9.549,16.943h0c-8.282,2.424-17.207-.419-22.56-7.187l-11.828-15.008c-1.262-1.595-1.339-3.91-.011-5.45,1.284-1.487,3.248-1.826,4.85-1.148.021-.064.05-.126.104-.174.102-.091.236-.112.359-.081l-2.191-2.77c-1.341-1.695-1.371-4.192.148-5.73,1.577-1.597,4.006-1.645,5.632-.342.005-.046.02-.084.041-.126l-.899-1.136c-1.17-1.479-1.259-3.972-.042-5.412,1.557-1.843,4.147-1.971,5.857-.612l.058-.057-6.79-8.019c-1.461-1.726-1.193-4.337.63-5.724,1.709-1.3,4.181-.87,5.569.769Z"
              fill="#ff9e85"
            ></path>
            <path
              id="b_4_ha_sh"
              d="m481.238,192.766c.016.042.039.082.071.118l6.686,7.712c.143.165.392.183.557.04.165-.142.182-.392.04-.557l-6.686-7.712c-.143-.165-.392-.183-.557-.04-.129.112-.168.289-.11.44Z"
              fill="#0c0c0c"
              opacity=".2"
            ></path>
            <path
              id="b_4_ha_sh-2"
              data-name="b_4_ha_sh"
              d="m476.458,199.787c.016.041.038.08.068.115l5.208,6.103c.142.166.391.186.557.044.166-.142.187-.391.044-.557l-5.208-6.103c-.142-.166-.391-.186-.557-.044-.131.112-.171.29-.113.442Z"
              fill="#0c0c0c"
              opacity=".2"
            ></path>
            <path
              id="b_4_ha_sh-3"
              data-name="b_4_ha_sh"
              d="m472.393,208.965c.017.044.042.085.075.122l2.527,2.825c.145.163.395.177.557.031.164-.146.179-.395.031-.558l-2.527-2.825c-.145-.163-.395-.177-.557-.031-.126.113-.163.287-.106.436Z"
              fill="#0c0c0c"
              opacity=".2"
            ></path>
          </g>
          <path
            d="m676.615,370.718l-141.087-9.874c-10.389-.727-19.433-7.364-23.243-17.056l-44.609-113.477,50.256-19.756,38.372,97.611,124.081,8.684-3.77,53.868Z"
            fill="#367cff"
          ></path>
          <g>
            <path
              d="m758.534,919.207s-4.515,23.404-26.428,24.708c-21.913,1.304-17.161,18.761-17.161,18.761h83.739v-41.837l-40.15-1.632Z"
              fill="#367cff"
            ></path>
            <path
              d="m784.363,492.277s-.263-7.036-.207,8.924c.207,59.529,1.24,127.525,3.764,167.315,4.057,63.964,14.459,265.628,14.459,265.628l-55.026-.462-53.333-443.823,90.342,2.419Z"
              fill="#262626"
            ></path>
            <path
              d="m722.224,562.475s-2.28,43.2-2.703,53.341c-.978,23.455-1.318,47.739-1.318,75.273l-8.674-72.18s6.347-22.621,12.695-56.434Z"
              fill="#0a0a0a"
            ></path>
            <path
              d="m660.573,919.207s-4.515,23.404-26.428,24.708c-21.913,1.304-17.161,18.761-17.161,18.761h83.739v-41.837s-40.15-1.632-40.15-1.632Z"
              fill="#367cff"
            ></path>
            <path
              d="m633.93,496.899s-4.874,203.456-4.16,213.4l20.464,222.303,54.117,1-5.274-231.343s3.72-63.816,19.139-123.073c7.912-30.406,12.613-61.557,14.168-92.938h0s-98.454,10.651-98.454,10.651Z"
              fill="#262626"
            ></path>
            <path
              d="m784.961,492.271l.18.01s-.13-3.47-.18-.01Z"
              fill="#333"
            ></path>
            <path
              d="m626.184,383.968c1.135,13.332,6.655,96.51,7.746,112.931h150.372c.849-14.811,4.664-79.575,7.885-108.539,3.075-27.638,9.108-41.475,4.686-49.646-7.226-13.354-26.972-21.071-40.436-22.894-8.222-1.113-20.587-1.911-20.587-1.911,0,0-1.047,21.181-26.013,22.359-33.986,1.603-31.716-22.359-31.884-22.359-5.506,0-37.565,2.589-44.653,8.046-12.396,9.545-9.525,33.759-7.116,62.012Z"
              fill="#367cff"
            ></path>
            <path
              d="m624.108,367.262c-.263,0-.483-.206-.499-.471l-1.213-21.171c-.016-.276.195-.512.47-.528.271-.012.512.195.528.47l1.213,21.171c.016.276-.195.512-.47.528-.01,0-.02,0-.029,0Z"
              fill="#0c0c0c"
            ></path>
          </g>
          <g>
            <path
              d="m816.812,496.028c8.397,0,16.401-3.854,21.635-10.558,5.849-7.491,7.408-17.475,4.12-26.393-1.553-4.213-37.973-100.656-44.906-118.526l-51.339,20.802c3.898,10.048,18.023,48.132,29.37,78.811l-18.852-2.049-5.934,54.585,62.935,3.167c.993.108,1.985.161,2.971.161Z"
              fill="#367cff"
            ></path>
            <path
              id="h_3_sk"
              d="m660.038,312.084c.168-.022,4.781,17.336,40.778,14.635,24.921-1.867,30.997-18.829,31.568-18.829-2.687-.571-7.05-1.164-8.243-1.801-3.924-2.108-6.783-4.675-8.221-10.183-1.125-4.308-1.698-20.891-1.698-29.211l-38.347,8.617c.534,9.385,4.275,31.143-8.836,34.994-2.182.637-4.532,1.223-6.999,1.779Z"
              fill="#ff9e85"
            ></path>
            <path
              d="m677.2,293.763c15.117,1.193,34.537-5.19,38.226-25.359l3.328-18.199c3.689-20.169-3.914-38.457-22.905-41.93h0c-18.99-3.473-36.175,10.281-39.864,30.45l-1.474,8.057c-1.415,7.739-4.284,44.853,22.688,46.981Z"
              fill="#ff9e85"
            ></path>
            <path
              d="m663.183,275.245c2.714-13.634,3.958-22.731,3.814-32.328-3.822-6.704-2.817-14.399-1.948-17.724-3.746,2.044-5.313,2.266-8.839,2.266,0,0,6.321-25.368,27.805-32.194,3.95-1.538,14.037-3.48,27.43-1.643,11.392,1.562,39.471,10.08,43.483,41.693h.002s0,.009.001.018c.133,1.048,2.829,30.175,8.204,44.15,7.226,18.787,17.37,24.624,17.113,46.299-.331,27.881-51.587,31.592-82.504,29.507-30.916-2.086-48.174-12.251-48.398-32.344-.251-22.513,8.407-20.422,13.837-47.7Z"
              fill="#0a0a0a"
            ></path>
          </g>
          <rect
            x="732.146"
            y="442.418"
            width="108.028"
            height="1"
            transform="translate(316.62 1213.473) rotate(-88.04)"
            fill="#0c0c0c"
          ></rect>
        </g>
        <path
          d="m60.486,964.677h885.111c.406,0,.737-.329.737-.737,0-.407-.33-.737-.737-.737H60.486c-.407,0-.737.329-.737.737s.329.737.737.737Z"
          fill="#292a2e"
        ></path>
      </g>
    </g>
  </svg>
</template>

<script setup></script>

<style></style>
